export default "__VITE_ASSET__D_dXzlOi__"